const endpoint = 'wss://ws.realsee.com'

export default endpoint
